import { Button, Checkbox, Drawer, Form, Slider } from 'antd';
import { SliderMarks } from 'antd/es/slider';
import { UserUseCaseInterface } from 'application/usecases/UserUseCase';
import GroupIcon from 'assets/icons/group-2.svg';
import SearchIcon from 'assets/icons/search-2.svg';
import XLargeIcon from 'assets/icons/x-large.svg';
import { Input } from 'antd';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppSelector } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DEFAULT_PARAMS, PARAMS } from 'utilities/constants/PARAMETER';
import { LOCAL_PARAMS } from '..';
import { MasterAreaData } from '../models/Master';

const MARK1: SliderMarks = {
    0: 0,
    1000: 1000,
    2000: 2000,
    3000: 3000,
    4000: 4000,
};

const MARK2: SliderMarks = {
    0: 0,
    10: 10,
    20: 20,
    30: 30,
    40: 40,
};
interface props {
    data: MasterAreaData[];
    userUseCase: UserUseCaseInterface;
}

export const SearchDrawer = ({ data, userUseCase }: props) => {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [areaData, setAreaData] = useState<MasterAreaData[]>([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [registerd, setRegisterd] = useState<boolean>(true);
    const [loanUnlimitFlag, setLoanUnlimitFlag] = useState<number>();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userSlice = useAppSelector((state) => state.user);

    const keyword = searchParams.get(PARAMS.KEYWORD) || DEFAULT_PARAMS.KEYWORD;
    const buyNowPriceMax = searchParams.get(LOCAL_PARAMS.BUYNOWPRICEMAX) || '4000';
    const buyNowPriceMin = searchParams.get(LOCAL_PARAMS.BUYNOWPRICEMIN) || '0';
    const oldMax = searchParams.get(LOCAL_PARAMS.OLDMAX) || '40';
    const oldMin = searchParams.get(LOCAL_PARAMS.OLDMIN) || '0';
    const areaId = searchParams.get(LOCAL_PARAMS.AREAID);

    useEffect(() => {
        userSlice.isSignedIn && getUserInfo();
    }, []);

    useEffect(() => {
        setAreaData(data);
    }, [JSON.stringify(data)]);

    useEffect(() => {
        initiateForm(data);
    }, [searchParams, JSON.stringify(data)]);

    const initiateForm = (data: MasterAreaData[]) => {
        let formArea: any[] = [];
        if (areaId === null) {
            formArea = data.map((element) => element.code);
        } else {
            const areaArr = areaId ? areaId.split(',') : [];
            formArea = areaArr.map((element) => Number(element));
        }

        form.setFieldsValue({
            text: keyword,
            buyNowPrice: [Number(buyNowPriceMin), Number(buyNowPriceMax)],
            age: [Number(oldMin), Number(oldMax)],
            checkBoxArea: formArea,
        });
    };

    const getUserInfo = async () => {
        try {
            dispatch(startFetching());
            const response = await userUseCase.getUserInfo();
            setRegisterd(!(userSlice.isSignedIn && response.result.accountRank >= 30 || parseInt(response.result.memberType) == 20))
            setLoanUnlimitFlag(response.result.loanUnlimitFlag);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const onClose = () => {
        setOpen(false);
    };

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const onSearch = () => {};

    const onFilter = () => {
        const keyword = form.getFieldValue('text');
        const buyNowPrice = form.getFieldValue('buyNowPrice');
        const age = form.getFieldValue('age');
        const isBalanced = form.getFieldValue('isBalanced');
        const checkBoxArea = form.getFieldValue('checkBoxArea');
        searchParams.set(PARAMS.KEYWORD, keyword ?? '');
        searchParams.set(LOCAL_PARAMS.AREAID, checkBoxArea ?? '');
        if (buyNowPrice) {
            const buyNowPriceMin = buyNowPrice[0];
            const buyNowPriceMax = buyNowPrice[1];
            searchParams.set(LOCAL_PARAMS.BUYNOWPRICEMAX, buyNowPriceMax.toString() ?? '');
            searchParams.set(LOCAL_PARAMS.BUYNOWPRICEMIN, buyNowPriceMin.toString() ?? '');
        }
        if (age) {
            const oldMin = age[0];
            const oldMax = age[1];
            searchParams.set(LOCAL_PARAMS.OLDMAX, oldMax.toString() ?? '');
            searchParams.set(LOCAL_PARAMS.OLDMIN, oldMin.toString() ?? '');
        }
        if(loanUnlimitFlag == 0){
            searchParams.set('isBalanced', isBalanced);
        }
        setSearchParams(searchParams);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <section
                onClick={() => toggleDrawer()}
                className="button-style center-inside search-drawer-1 "
                style={{ width: 'fit-content' }}
            >
                <img alt="" src={SearchIcon} />
                <div className="search-font">検索</div>
            </section>
            <Drawer
                mask={false}
                className="disappear-close  search-drawer-1"
                closeIcon={null}
                title={<p className="search-drawer-title">物件検索</p>}
                width={304}
                open={open}
                extra={
                    <div
                        onClick={onClose}
                        className="button-style"
                        style={{ height: '100%', display: 'flex', alignItems: 'center' }}
                    >
                        <img src={XLargeIcon} alt="" />
                    </div>
                }
            >
                <Form form={form} style={{ paddingLeft: 16, paddingRight: 16, margin: 0 }}>
                     <Form.Item name="text" style={{ marginBottom: 16 }}>
                        <Input style={{ width: '100%' }} size="large" maxLength={100} prefix={<img alt="" src={SearchIcon} />} placeholder = '物件名から探す' />
                    </Form.Item>
                    <Form.Item name="checkBoxArea" style={{ margin: 0, padding: 0, width: '100%' }}>
                        <Checkbox.Group style={{ margin: 0, padding: 0, width: '100%' }}>
                            {areaData.map((element) => {
                                return (
                                    <div className="filter-area-container" key={element.code}>
                                        <Checkbox value={element.code} className="checkbox-font">
                                            {element.name}
                                        </Checkbox>
                                        <div className="number-badge center-inside">
                                            {element.numberProperty}
                                        </div>
                                    </div>
                                );
                            })}
                        </Checkbox.Group>
                    </Form.Item>

                    <div className="search-label" style={{ marginTop: 10, marginBottom: 12 }}>
                        即決価格（万円）
                    </div>
                    <div style={{ width: '100%', paddingRight: 10 }}>
                        <Form.Item
                            name="buyNowPrice"
                            style={{ margin: 0, padding: 0, width: '100%' }}
                            >
                            <Slider
                                range
                                min={0}
                                max={4000}
                                marks={MARK1}
                                step={100}
                                defaultValue={[0, 4000]}
                            />
                        </Form.Item>
                    </div>

                    <div className="search-label" style={{ marginTop: 10, marginBottom: 12 }}>
                        築年数（年）
                    </div>
                    <div style={{ width: '100%', paddingRight: 10 }}>
                        <Form.Item name="age" style={{ margin: 0, padding: 0, width: '100%' }}>
                            <Slider
                                range
                                min={0}
                                max={40}
                                marks={MARK2}
                                step={1}
                                defaultValue={[0, 40]}
                            />
                        </Form.Item>
                    </div>
                    {userSlice.isSignedIn &&(
                        <section style={{ width: '100%', marginTop: 24 }}>
                            <Form.Item
                                className="ant-checkbox-disabled-font"
                                name="isBalanced"
                                label={false}
                                valuePropName="checked"
                                style={{ margin: 0, padding: 0 }}
                            >
                                <Checkbox
                                    className="drawer-checkbox-font  ant-checkbox-disabled-font"
                                    disabled={registerd}
                                    checked={false}
                                >
                                    <div className="center-inside">
                                        <span
                                            className=""
                                            style={{ marginRight: 8, color: '#000', padding: 0 }}
                                        >
                                            融資限度額で購入可能
                                        </span>{' '}
                                        {userSlice.isSignedIn && registerd && <img alt="" src={GroupIcon} />}
                                    </div>
                                </Checkbox>
                            </Form.Item>
                        </section>
                    )}
                    {registerd && userSlice.isSignedIn && (
                        <section className="last-line-search" style={{ display: 'flex' }}>
                            <div
                                className="button-style"
                                style={{ color: '#1F8DDD', marginRight: 1.600000023841858 }}
                                onClick={() =>
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_004_00}`,
                                    )
                                }
                            >
                                基本情報の登録
                            </div>
                            <div>の後、選択可能になります。</div>
                        </section>
                    )}

                    <Button
                        className="button-blue-custom-2"
                        style={{ width: '100%', height: 56, letterSpacing: -1.5, marginTop: 43.5 }}
                        onClick={() => onFilter()}
                    >
                        検索
                    </Button>
                </Form>
            </Drawer>
        </React.Fragment>
    );
};
